<template>
    <div class="text-center">
        <v-menu v-model="menu" :close-on-content-click="false" max-width="300" location="bottom">
            <template v-slot:activator="{ props }">
                <v-btn color="indigo" icon size="small" v-bind="props">{{ userInitial }}</v-btn>
            </template>

            <v-card min-width="220">
                <v-list>
                    <v-list-item :title="userFullName" :subtitle="userEmail">
                        <template v-slot:prepend>
                            <v-avatar>
                                <v-img src="/img/user.png" alt="moi" />
                            </v-avatar>
                        </template>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list>
                    <v-list-item link @click="logout" title="Déconnexion">
                        <template v-slot:prepend>
                            <v-icon>mdi-logout</v-icon>
                        </template>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>

        <!-- Deconnexion Loader -->
        <v-dialog v-model="dialog" :scrim="false" persistent width="350">
            <v-card class="pa-3">
                <div class="text-center">
                    <div class="font-weight-medium">Déconnexion en cours. Veuillez patienter</div>
                    <v-progress-circular :size="50" color="primary" indeterminate class="mt-5"></v-progress-circular>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'UserDropdown',
    data() {
        return {
            menu: false,
            dialog: false
        };
    },
    computed: {
        user() {
            const storeUser = this.$store.getters['auth/user'] || {};
            if (storeUser && storeUser.data && typeof storeUser.data === 'object' && !Array.isArray(storeUser.data)) {
                return storeUser.data;
            }
            return storeUser || {};
        },
        userInitial() {
            const firstName = this.user.prenom || this.user.first_name || this.user.name || '';
            const lastName = this.user.nom || this.user.last_name || '';
            return (firstName || lastName || 'U').charAt(0).toUpperCase();
        },
        userFullName() {
            const firstName = this.user.prenom || this.user.first_name || '';
            const lastName = this.user.nom || this.user.last_name || '';
            return [firstName, lastName].filter(Boolean).join(' ').trim() || this.user.name || 'Utilisateur';
        },
        userEmail() {
            return this.user.email || this.user.mail || '';
        }
    },
    methods: {
        logout() {
            this.dialog = true;
            axios
                .post('logout')
                .then(() => {
                    this.$store.commit('auth/SET_LOGGED', { user: null, isLoggedIn: false });
                    location.href = `${location.origin}/`;
                })
                .catch((error) => {
                    this.dialog = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Erreur !',
                        text: error.message
                    });
                });
        }
    }
};
</script>
